module.exports = __webpack_public_path__ + "fonts/Lato-Hairline.779c2da4.eot";